import React, { useContext, useEffect, useRef, useState } from "react";
import { useLoader } from "../../../Loader/LoaderContext";
import {
  getService,
  postService,
  putService,
} from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  getCurrencySymbol,
  getDisplayCompany,
  getDotColor,
  getStatusClass,
  getStatusDisplayName,
} from "../../../utility/RolesUtility";

import { useToaster } from "../../../Toaster/Toaster";
import FilterPopup from "../Modals/FilterPopup";
import { LeadsDto } from "../../../api/interfaces/LeadsDto";
import DeclinedPopup from "../Modals/DeclinedPopup";
import Pagination from "../usersMangmnt/Pagination";
import { SidebarContext } from "../Sidebar/SidebarContext";
import { handleRedirection } from "../../../utility/navigationHelper";
import DynamicSuccessPopup from "../Modals/DynamicSuccessPopup";
import DynamicTextPopup from "../Modals/dynamicTextPopup";

interface LeadsTableProps {
  leads: LeadsDto[]; // Use DTO for leads prop
}
const services = [
  { key: "isBannerAds", label: "Banner ads" },
  { key: "isEmailMarketing", label: "Email marketing" },
  { key: "isContentMarketing", label: "Content Marketing" },
  { key: "isEventListing", label: "Event listing" },
  { key: "isNewsLetterAds", label: "Newsletter ads" },
  { key: "isPrintAd", label: "Print ad" },
  { key: "isCompanyProfiling", label: "Company Profiling" }, // Add profiling services
  { key: "isHospitalProfiling", label: "Hospital Profiling" }, // Add profiling services
  { key: "isEventProfiling", label: "Event Profiling" }, // Add profiling services
];
const getSource: Record<string, string> = {
  INTERNAL: "Internal",
  REFRAL: "Refral",
  INBOUND_CALL: "Inbound Call",
  INT_PROMOTIONS: "Int Promotions",
  SOCIAL_MEDIA: "Social Media",
  WEBSITE: "Website",
};
const ActiveVendors: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;
  const { showToast } = useToaster();
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [searchQueryValue, setSearchQueryValue] = useState<string>(() => {
    return sessionStorage.getItem("searchQueryValue") || "";
  });

  const [currentPage, setCurrentPage] = useState<number>(() => {
    const savedPage = sessionStorage.getItem("currentPage");
    return savedPage ? parseInt(savedPage) : 0;
  });

  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const [totalElement, setTotalElements] = useState(0);

  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const fetchVehicle = async (id: number) => {
    setLoading(true);
    let body: any;
    try {
      let url: any;

      const response = await getService(url + "?leadId=" + id);
      setTimeout(() => {
        if (response.data?.length) {
          navigate(
            "/portals/proposals/viewProposal/viewServiceReq?appUserId=" + id
          );
        }
      }, 300);
    } catch (error) {
      showToast("error", "error", "");
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  useEffect(() => {
    fetchVehicles();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentPage, searchQueryValue, isRefreshPage, location]);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const viewCallBack = (data: any) => {
    // if( data.dataType === 'VENDOR'){
    // fetchData(data?.id);
    navigate(
      "/portals/vendors/activeVendor/viewServiceReq?appUserId=" +
        data?.id +
        "&activeVendors=" +
        "activevendors"
    );
    // }
  };
  const fetchData = async (id: number) => {
    setLoading(true);
    let body: any;
    try {
      let url: any;

      const response = await getService(
        API_ENDPOINTS.getActiveServiceReq + "?proposalId=" + id
      );
      setTimeout(() => {
        if (response.data?.length) {
          navigate(
            "/portals/proposals/activeVendor/viewServiceReq?appUserId=" +
              id +
              "&activeVendors=" +
              "activevendors"
          );
        }
      }, 300);
    } catch (error) {
      showToast("error", "error", "");
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  const fetchVehicles = async () => {
    setLoading(true);
    let body: any;
    body = {
      page: currentPage,
      search: searchQueryValue,
    };
    try {
      let url: any;

      url = API_ENDPOINTS.getActiveVendors;

      const response = await postService(url, body);
      setTableData(response.data.content);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      showToast("error", "error", "");
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
  const onPageChange = async (page: any) => {
    setCurrentPage(page);
    sessionStorage.setItem("currentPage", page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const viewServices = (data: any) => {
    navigate(
      "/portals/vendors/activeVendor/serviceDetails?bookingid=" + data?.leadId
    );
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchQuery = event.target.value;

    // Update state
    setSearchQueryValue(newSearchQuery);
    setCurrentPage(0);

    // Persist to sessionStorage
    sessionStorage.setItem("searchQueryValue", newSearchQuery);
    sessionStorage.setItem("currentPage", "0");
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      sessionStorage.removeItem("currentPage");
      sessionStorage.removeItem("searchQueryValue");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const usersScreen = () => {
    navigate("/portals/proposals/viewProposal");
  };
  const viewLeadType = (user: LeadsDto) => {
    console.log(user);
    if (user.leadType === "HOSPITAL") {
      navigate(
        "/portals/vendors/activeVendor/previewHospital?leadId=" + user?.leadId
      );
    } else if (user?.leadType === "COMPANY") {
      navigate(
        "/portals/vendors/activeVendor/previewCompany?leadId=" + user?.leadId
      );
    } else if (user?.leadType === "EVENT_ORGANIZER") {
      navigate(
        "/portals/vendors/activeVendor/eventPreview?leadId=" + user?.leadId
      );
    }
  };
  const handleCreateProposal = async (data: any) => {
    let text: string = "";
    navigate(
      "/portals/proposals/addProposal?leadId=" +
        data.id +
        "&createNewProposal=" +
        "activeVendros"+
        '&proposalFrom='+
        'activeVendors'
    );
  };
  const viewProfile = (data: any) => {
    if (
      userInfo?.roles !== "CONTENT_ADMIN" &&
      userInfo?.roles !== "PUBLISHER" &&
      userInfo?.roles !== "CHIEF_EDITOR"
    ) {
      navigate(
        "/portals/vendors/activeVendor/ViewDetails?appUserId=" + data?.leadId
      );
    }
  };
  const viewPropsoal = (data: any) => {
    navigate(
      "/portals/vendors/activeVendor/viewPaymentsDetails?appUserId=" +
        data?.vendorUserId +
        "&vendorUUID=" +
        data?.vendorUserUuId +
        "&type=" +
        data?.type
    );
  };
  const viewDashboard = async (data: any) => {
    await handleRedirection(navigate, data?.vendorUserId);
    localStorage.setItem("vendorId", data.vendorUserId);
    localStorage.setItem("leadId", data.leadId);
    localStorage.setItem("screen", "active");
  };
  const [data, setData] = useState<any>(null);
  const [isUnlist, setShowUnlist] = useState(false);
  const [isShows, setshowPop] = useState(false);

  const [isShowUnlistSuccess, setUnlistedSuccess] = useState(false);
  const [isShowSuccess, setSucces] = useState(false);
  const listEvent = (data: any) => {
    setshowPop(true);
    setData(data);
  };
  const UnlistEvent = (data: any) => {
    setData(data);
    setShowUnlist(true);
  };
  const closeUnlistEvent = () => {
    setShowUnlist(false);
  };
  const closePops = () => {
    setSucces(false);
    fetchVehicles();
  };
  const closePopUnlisted = () => {
    setUnlistedSuccess(false);
    fetchVehicles();
  };
  const unsaveEventList = async () => {
    setLoading(true);
    try {
      let url: any;
      const response = await putService(
        API_ENDPOINTS.unListEvent + "?leadId=" + data?.leadId,
        {}
      );
      closeUnlistEvent();
      setUnlistedSuccess(true);
    } catch (error: any) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
      showToast(error?.response?.data?.message, "error", "");
    } finally {
      setLoading(false);
    }
  };
  const saveEvent = async () => {
    setLoading(true);
    try {
      let url: any;
      const response = await putService(
        API_ENDPOINTS.listEvent + "?leadId=" + data?.leadId,
        {}
      );
      handleClosePopup1();
      setSucces(true);
    } catch (error: any) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
      showToast(error?.response?.data?.message, "error", "");
    } finally {
      setLoading(false);
    }
  };
  const handleClosePopup1 = () => {
    setshowPop(false);
  };

  return (
    <div className="h-full py-2 w-full relative">
      <div className="flex items-center mb-3 mt-2 cursor-pointer justify-between">
        <div className="flex items-center ">
          <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F] mr-3">
            Active Vendors
          </h1>
          <input
            type="text"
            placeholder="search"
            className="p-2 border border-[#D1D5DB] w-[300px] rounded-md mr-3"
            value={searchQueryValue}
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className="overflow-x-auto ">
        <table className="min-w-full bg-white border border-gray-200 ">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10 whitespace-nowrap">
                Vendor ID
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10 whitespace-nowrap">
                Company Name
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                Company Type
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                Contact Name
              </th>
              {userInfo?.roles !== "PUBLISHER" &&
                userInfo?.roles !== "CONTENT_ADMIN" &&
                userInfo?.roles !== "CHIEF_EDITOR" && (
                  <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                    Booking Date
                  </th>
                )}
              {userInfo?.roles !== "PUBLISHER" &&
                userInfo?.roles !== "CONTENT_ADMIN" &&
                userInfo?.roles !== "CHIEF_EDITOR" && (
                  <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky bg-gray-100 left-0 z-10 whitespace-nowrap">
                    Booking Type
                  </th>
                )}
              {userInfo?.roles !== "PUBLISHER" &&
                userInfo?.roles !== "CONTENT_ADMIN" &&
                userInfo?.roles !== "CHIEF_EDITOR" && (
                  <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                    Booking Value
                  </th>
                )}
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                Active Services
              </th>
              {userInfo?.roles === "PUBLISHER" && (
                <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                  Profile Approval Status
                </th>
              )}
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                Service End Date
              </th>
              {userInfo?.roles !== "PUBLISHER" &&
                userInfo?.roles !== "CONTENT_ADMIN" &&
                userInfo?.roles !== "CHIEF_EDITOR" && (
                  <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                    Proposal & Payments
                  </th>
                )}
              {userInfo?.roles !== "PUBLISHER" &&
                userInfo?.roles !== "CONTENT_ADMIN" &&
                userInfo?.roles !== "CHIEF_EDITOR" && (
                  <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                    Callback Request
                  </th>
                )}

              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs whitespace-nowrap">
                Source
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((user: LeadsDto, index: number) => (
              <tr key={index}>
                <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                  {user.vendorUserUuId || "NA"}
                </td>
                <td
                  className="px-4 py-3 border-b text-sm text-gray-900 font-semibold sticky left-0 z-10 cursor-pointer bg-white whitespace-nowrap"
                  onClick={() => viewProfile(user)}
                >
                  {user?.companyName ? user?.companyName : "NA"}
                </td>
                <td
                  className="px-4 py-3 border-b text-sm text-blue-500 cursor-pointer  whitespace-nowrap"
                  onClick={() => viewLeadType(user)}
                >
                  {user.leadType
                    ? getDisplayCompany(user.leadType)
                    : getDisplayCompany(user.type)}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                  {user.contactPersonName ? user.contactPersonName : "NA"}
                </td>
                {userInfo?.roles !== "PUBLISHER" &&
                  userInfo?.roles !== "CONTENT_ADMIN" &&
                  userInfo?.roles !== "CHIEF_EDITOR" && (
                    <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                      {user.bookingDate ? user.bookingDate : "NA"}
                    </td>
                  )}
                {userInfo?.roles !== "PUBLISHER" &&
                  userInfo?.roles !== "CONTENT_ADMIN" &&
                  userInfo?.roles !== "CHIEF_EDITOR" && (
                    <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                      {user.type ? getDisplayCompany(user.type) : "NA"}
                    </td>
                  )}
                {userInfo?.roles !== "PUBLISHER" &&
                  userInfo?.roles !== "CONTENT_ADMIN" &&
                  userInfo?.roles !== "CHIEF_EDITOR" && (
                    <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                      <span>
                        {user?.value
                          ? getCurrencySymbol(user?.mtCurrencyDto?.id ?? "")
                          : ""}{" "}
                        {user.value ? user.value : "NA"}
                      </span>
                    </td>
                  )}

                <td
                  className="px-4 py-3 border-b text-sm text-blue-500 relative group whitespace-nowrap"
                  onClick={() => viewServices(user)}
                >
                  {services.filter(
                    (service) => user[service.key as keyof typeof user]
                  ).length > 0 ? (
                    <div>
                      <span className="cursor-pointer">
                        {services
                          .filter(
                            (service) =>
                              user[service.key as keyof typeof user] &&
                              (service.key === "isCompanyProfiling" ||
                                service.key === "isHospitalProfiling" ||
                                service.key === "isEventProfiling")
                          )
                          .slice(0, 1) // Display the first profiling service if it exists
                          .map((service) => service.label)}
                        {
                          // If no profiling service is active, fall back to the first active non-profiling service
                          !services.some(
                            (service) =>
                              user[service.key as keyof typeof user] &&
                              (service.key === "isCompanyProfiling" ||
                                service.key === "isHospitalProfiling" ||
                                service.key === "isEventProfiling")
                          ) &&
                            services
                              .filter(
                                (service) =>
                                  user[service.key as keyof typeof user]
                              )
                              .slice(0, 1)
                              .map((service) => service.label)
                        }
                        {services.filter(
                          (service) => user[service.key as keyof typeof user]
                        ).length > 1 && (
                          <>
                            <span className="font-normal text-[10px] leading-[6px] tracking-[0.014em] bg-clip-text text-transparent bg-gradient-to-r from-[#E33E5F] to-[#B00A2B]">
                              {" "}
                              +
                            </span>
                            <span className="font-normal text-[10px] leading-[6px] tracking-[0.014em] bg-clip-text text-transparent bg-gradient-to-r from-[#E33E5F] to-[#B00A2B]">
                              {services.filter(
                                (service) =>
                                  user[service.key as keyof typeof user]
                              ).length - 1}
                            </span>
                          </>
                        )}
                      </span>
                      {services.filter(
                        (service) => user[service.key as keyof typeof user]
                      ).length > 1 && (
                        <div className="absolute bottom-[20px] left-[120px] mt-2 w-40 bg-[#FCF3F5F7] border rounded-lg shadow-lg p-2 pl-4 hidden group-hover:block z-10 text-[#6B7280] font-normal">
                          {services
                            .filter(
                              (service) =>
                                user[service.key as keyof typeof user] &&
                                !(
                                  service.key === "isCompanyProfiling" ||
                                  service.key === "isHospitalProfiling" ||
                                  service.key === "isEventProfiling"
                                )
                            )
                            .map((service, idx) => (
                              <div key={idx}>
                                <span>{service.label}</span>
                              </div>
                            ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <span>NA</span> // Display "NA" if no services are active
                  )}
                </td>
                {userInfo?.roles === "PUBLISHER" && (
                  <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                    {user?.profilingStatus === "NONE" ||
                    !user?.profilingStatus ? (
                      "Not Applicable"
                    ) : user?.profilingStatus === "SEND_FOR_APPROVAL" ? (
                      <span className="text-red-500">{`Received on ${user?.sendForAprvlOn}`}</span>
                    ) : user?.profilingStatus === "PUBLISHED" ? (
                      `Approved on ${user?.publishedOn} by ${user?.publishedBy}`
                    ) : user?.profilingStatus === "TO_SEND_FOR_APPROVAL" ? (
                      "Not sent for approval yet"
                    ) : (
                      ""
                    )}
                  </td>
                )}
                <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                  {user.expiryDate ? user.expiryDate : "NA"}
                </td>
                {userInfo?.roles !== "PUBLISHER" &&
                  userInfo?.roles !== "CONTENT_ADMIN" &&
                  userInfo?.roles !== "CHIEF_EDITOR" && (
                    <td
                      className="px-4 py-3 border-b text-sm cursor-pointer whitespace-nowrap text-blue-500"
                      onClick={() => viewPropsoal(user)}
                    >
                      View
                    </td>
                  )}
                {userInfo?.roles !== "PUBLISHER" &&
                  userInfo?.roles !== "CONTENT_ADMIN" &&
                  userInfo?.roles !== "CHIEF_EDITOR" && (
                    <td
                      className={`px-4 py-3 border-b text-sm whitespace-nowrap cursor-pointer ${
                        user?.serviceReqType ? "text-red-500" : "text-gray-500"
                      }`}
                      onClick={() => user?.serviceReqType && viewCallBack(user)}
                    >
                      {user?.callBackDate &&
                      user?.serviceReqType === "EMAIL_REQ"
                        ? "e-response"
                        : user?.callBackDate
                        ? user.callBackDate
                        : "-"}
                    </td>
                  )}
                <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap">
                  <div className="flex justify-between items-center">
                    {user.source ? getSource[user.source] : "NA"}{" "}
                    {/* { (userInfo?.roles !=='PUBLISHER' &&  userInfo?.roles !=='CONTENT_ADMIN' && userInfo?.roles !=='CHIEF_EDITOR') && */}
                    <img
                      src="/images/threeDot.svg"
                      alt="Menu"
                      className="cursor-pointer ml-5"
                      onClick={() => toggleDropdown(index)}
                    />
                    {activeDropdown === index && (
                      <div
                        ref={dropdownRef}
                        className="absolute right-[22px] mt-2 w-48 bg-white px-3 border border-gray-300 rounded-md shadow-lg z-10"
                      >
                        <div className="py-2">
                          {userInfo?.roles !== "PUBLISHER" &&
                            userInfo?.roles !== "CONTENT_ADMIN" &&
                            userInfo?.roles !== "CHIEF_EDITOR" && (
                              <div
                                onClick={() => handleCreateProposal(user)}
                                className="flex gap-2 items-center w-full cursor-pointer"
                              >
                                {" "}
                                <img src="/images/editIcon.svg" />
                                <a
                                  href="#"
                                  className="block py-2 text-sm text-[#374151] font-normal "
                                >
                                  Create new Proposal
                                </a>
                              </div>
                            )}
                          {user?.isEventUnListing ? (
                            <div
                              onClick={() => UnlistEvent(user)}
                              className="flex gap-2 items-center w-full cursor-pointer"
                            >
                              <img src="/images/tickIcon.svg" />
                              <a
                                href="#"
                                className="block py-2 text-sm text-gray-700"
                              >
                                Un List Event
                              </a>
                            </div>
                          ) : user?.isEventListingAvailable ? (
                            <div
                              onClick={() => listEvent(user)}
                              className="flex gap-2 items-center w-full cursor-pointer"
                            >
                              <img src="/images/tickIcon.svg" />
                              <a
                                href="#"
                                className="block py-2 text-sm text-gray-700"
                              >
                                List Event
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          {(userInfo?.roles === "PUBLISHER" ||
                            userInfo?.roles === "CONTENT_ADMIN" ||
                            userInfo?.roles === "CHIEF_EDITOR" ||
                            userInfo?.roles === "SALES_ADMIN") && (
                            <div
                              onClick={() => viewDashboard(user)}
                              className="flex gap-2 items-center w-full cursor-pointer"
                            >
                              {" "}
                              <img src="/images/dashboardIcon.svg" />
                              <a
                                href="#"
                                className="block py-2 text-sm text-[#374151] font-normal "
                              >
                                View Dashboard
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {!tableData.length && (
          <p className="text-center p-2 bg-white">No data to display</p>
        )}

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalElement={totalElement}
            onPageChange={onPageChange}
            onNext={onNext}
            onPrevious={onPrevious}
          />
        )}
        {isShows && (
          <DynamicTextPopup
            onClose={handleClosePopup1}
            title="Confirm List Event"
            body=" Are you sure you want to list events"
            confirmButtonName="Yes"
            closeButtonName="Cancel"
            onConfirm={saveEvent}
          />
        )}
        {isUnlist && (
          <DynamicTextPopup
            onClose={closeUnlistEvent}
            title="Confirm Un List Event"
            body="Are you sure you want to Un list events"
            confirmButtonName="Yes"
            closeButtonName="Cancel"
            onConfirm={unsaveEventList}
          />
        )}
        {isShowSuccess && (
          <DynamicSuccessPopup
            onClose={closePops}
            title="Listed Event Successfully!"
            body="The event is Successfully listed"
            closeButtonName="Ok"
          />
        )}
        {isShowUnlistSuccess && (
          <DynamicSuccessPopup
            onClose={closePopUnlisted}
            title="UnListed Event Successfully!"
            body="The event is Successfully un listed"
            closeButtonName="Ok"
          />
        )}
      </div>
    </div>
  );
};

export default ActiveVendors;
